import { useTranslation } from "react-i18next";
import { Title, Section, SectionTitle, Paragraph, ParagraphTight, ItemBlock, Bullets, Ordered, MainSection, } from "./styled";
import NavigationBar from "../../components/NavigationBar";
import Footer from "../../components/Footer";

const isObject = (v) => v && typeof v === "object" && !Array.isArray(v);

const PrivacyPolicy = () => {
    const { t } = useTranslation("policy");

    const sections = t("sections", { returnObjects: true });

    return (
        <main>
            <NavigationBar variant="policy" />
            <MainSection id="home">
                <Title>{t("title")}</Title>

                {Array.isArray(sections) &&
                    sections.map((section, idx) => (
                        <Section key={idx}>
                            <SectionTitle>{section.title}</SectionTitle>

                            {section.items?.map((item, i) => {
                                if (typeof item === "string") {
                                    return <Paragraph key={i}>{item}</Paragraph>;
                                }

                                if (isObject(item)) {
                                    return (
                                        <ItemBlock key={i}>
                                            <ParagraphTight>{item.text}</ParagraphTight>

                                            {Array.isArray(item.bullets) && (
                                                <Bullets>
                                                    {item.bullets.map((b, bi) => (
                                                        <li key={bi}>{b}</li>
                                                    ))}
                                                </Bullets>
                                            )}

                                            {Array.isArray(item.ordered) && (
                                                <Ordered>
                                                    {item.ordered.map((o, oi) => (
                                                        <li key={oi}>{o}</li>
                                                    ))}
                                                </Ordered>
                                            )}
                                        </ItemBlock>
                                    );
                                }

                                return null;
                            })}
                        </Section>
                    ))}
            </MainSection>
            <Footer />
        </main>
    );
};

export default PrivacyPolicy;